<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-header">
          <router-link :to="'entities/new'" class="btn btn-secondary btn-sm pull-right" exact style="margin-top: 2px">
            <i class="fa fa-plus"></i> Nova Entidade
          </router-link>
          <div class="form-inline">
            <div class="input-group" :class="{'has-danger': errors.has('entidade') || errors.has('id') }">
              <input class="form-control mr-sm-2" type="text" name="entidade" placeholder="entidade" v-model="searchData.entity" v-validate="'required'">
              <input class="form-control mr-sm-2" type="text" name="id" placeholder="id" v-model="searchData.id" v-validate="'required'">
              <button type="button" class="btn btn-sm btn-secondary my-2 my-sm-0" @click.prevent="search"><i class="fa fa-search"></i> Buscar</button>
            </div>
          </div>
        </div>
        <div class="card-block" v-if="loaded">
          <vue-json-editor v-model="entity" :showBtns="false" @json-change="onJsonChange"></vue-json-editor>
          <br>
          <div>
            <router-link :to="`entities/${searchData.entity}/${searchData.id}`" class="btn btn-sm btn-secondary pull-right">
              <i class="fa fa-edit"></i> Editar
            </router-link>
          </div>
        </div>
        <div class="card-block" v-if="!loaded">
          {{message}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vueJsonEditor from 'vue-json-editor'

export default {
  name: 'entities',
  components: { vueJsonEditor },
  data () {
    return {
      searchData: {
        entity: '',
        id: ''
      },
      entity: {},
      message: '',
      loaded: false
    }
  },
  created () {
    this.message = 'Preencha com o nome da Entidade e seu Id para buscar...'
  },
  methods: {
    onJsonChange (value) {
    },
    search () {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        this.loaded = false
        this.message = 'Buscando...'
        var query = 'cerebro?id=' + this.searchData.id + '&entity=' + this.searchData.entity
        axios.get(process.env.API_URL + query).then(response => {
          this.entity = response.data
          this.loaded = true
        }).catch(err => {
          console.log(err.response)
          if (err.response.status === 404) {
            this.showInfo('Entidade não encontrada...')
          } else {
            this.showError('Ops. Ocorreu um erro ao carregar a entidade.')
          }

          this.loaded = false
          this.message = 'Preencha com o nome da Entidade e seu Id para buscar...'
        })
      }
    }
  }
}
</script>
<style>
  div.jsoneditor {
    border: 1px solid #9e9e9e;
  }

  div.jsoneditor-menu {
    background-color: #9e9e9e;
    border-bottom: 1px solid #9e9e9e;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?07cfca5a